import * as z from "zod";
import { useBoundStore } from "@/services/stores";
import { selectActiveApplicationData } from "@/services/stores/selectors/applications";
import { forEach } from "lodash";
import { DocTypeIds } from "@/constants";

export const AttachmentSchema = z.object({
  name: z.string({
    required_error: "Name is required",
    invalid_type_error: "Name must be a string",
  }),
  type: z.string({
    required_error: "Type is required",
    invalid_type_error: "Type must be a string",
  }),
  size: z.number({
    required_error: "Size is required",
    invalid_type_error: "Size must be a string",
  }),
  base64: z.string({
    required_error: "Base64 is required",
    invalid_type_error: "Base64 must be a string",
  }),
});

export const AttachmentFieldFormDataSchema = () => {
  const { activeApplication } = useBoundStore(selectActiveApplicationData);
  const docs = activeApplication?.RequiredDocuments;

  const resolver = {};

  forEach(docs, doc => {
    if (
      doc.DocTypeId === DocTypeIds.Subcontractor ||
      doc.DocTypeId === DocTypeIds.Contractor ||
      doc.IsMandatory
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      resolver[doc.DocTypeId] = AttachmentSchema;
    }
  });

  return z.object(resolver);
};
